<template>
    <v-container fluid>
        <!--
        <v-btn
            :loading="medikreditclaimCsvsWithInfo === null"
            @click="newMedikreditClaimCsv"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        -->
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Medikredit-Claim Files ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="medikreditclaimCsvsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="medikreditclaimCsvWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="medikreditclaimCsvWithInfo in medikreditclaimCsvsWithInfo"
                >
                    <!--@click="loadMedikreditClaimCsvForm(medikreditclaimCsvWithInfo.entity)"-->
                    <v-card
                        @click="loadMedikreditClaimCsvForm(medikreditclaimCsvWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>
                                File: {{filenameRegex.exec(medikreditclaimCsvWithInfo.entity.originalFileName)[0]}}
                                <br />
                                CreatedAt: {{medikreditclaimCsvWithInfo.entity.createdAt}}
                            </h5>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="20"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>

        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="medikreditclaimCsvFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeMedikreditClaimCsvForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="start"
                    >
                    <v-col cols=12>
                        <json-viewer :key="jvkey" :value="medikreditclaimCsvDisplayEntity"></json-viewer>
                    </v-col>
                        
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
    </v-container>
</template>

<script>
//import MedikreditClaimCsv from "../models/MedikreditClaimCsv.model";
import uuid4 from "../helpers/uuid4";
//import MedikreditClaimCsv from "../models/MedikreditClaimCsv.model";

export default {
    name: "MedikreditClaimCsvs",
    props: ["status"],
    data: function() {
        return {
            //main data
            medikreditclaimCsvsWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            paginationTimeout: null,
            requestId: uuid4(),
            filenameRegex: /[^\\]*$/,

            //form
            medikreditclaimCsvFormVisible: false,
            medikreditclaimCsvDisplayEntity: null,
            jvkey: 0,
        };
    },
    mounted: function() {
        this.getMedikreditClaimCsvs();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        //
    },
    methods: {
        getMedikreditClaimCsvs() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("medikreditclaimcsvs/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString
                    },
                    requestId: requestId
                })
                .then(medikreditclaimCsvsResponse => {
                    if (
                        this.requestId == medikreditclaimCsvsResponse.requestId
                    ) {
                        this.medikreditclaimCsvsWithInfo =
                            medikreditclaimCsvsResponse.data.page;
                        this.totalMatches =
                            medikreditclaimCsvsResponse.data.total;
                        this.pageSize =
                            medikreditclaimCsvsResponse.data.pageSize;
                        this.pageNo =
                            medikreditclaimCsvsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            medikreditclaimCsvsResponse.data.total /
                                this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.medikreditclaimCsvsWithInfo !== null)
                this.medikreditclaimCsvsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getMedikreditClaimCsvs,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        loadMedikreditClaimCsvForm(medikreditclaimCsv) {
            this.medikreditclaimCsvDisplayEntity = JSON.parse(medikreditclaimCsv.serializedContent);
            this.medikreditclaimCsvFormVisible = true;
        },
        closeMedikreditClaimCsvForm() {
            this.medikreditclaimCsvDisplayEntity = null;
            this.medikreditclaimCsvFormVisible = false;
            this.jvkey += 1;
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
